import { render, staticRenderFns } from "./health-risk-factor.vue?vue&type=template&id=1d39e29e&scoped=true"
import script from "./health-risk-factor.vue?vue&type=script&lang=js"
export * from "./health-risk-factor.vue?vue&type=script&lang=js"
import style0 from "./health-risk-factor.vue?vue&type=style&index=0&id=1d39e29e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d39e29e",
  null
  
)

export default component.exports